import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';

import { generateUUIDv4 } from '@/utils/number';
import Button from '@/views/components/Buttons/Button';

import PreClaimsFilesCard from './PreClaimsFilesCard';

const PreClaimsFiles = ({ filesList, setFilesList, onFieldsChange }) => {
  const setEditMode = (index, val) => {
    const filesLocal = cloneDeep(filesList);
    filesLocal[index].editMode = val;
    setFilesList(filesLocal);
  };

  const handleCancel = (index, isNew) => {
    const filesLocal = cloneDeep(filesList);
    if (isNew) {
      filesLocal.splice(index, 1);
    } else {
      filesLocal[index].editMode = false;
    }
    setFilesList(filesLocal);
  };

  const handleSubmit = (data, index) => {
    const filesLocal = cloneDeep(filesList);
    const currentBlock = filesLocal[index];

    const existingIndex = filesLocal.findIndex((b, i) => b.documentType === data.documentType && i !== index);

    if (existingIndex >= 0) {
      filesLocal[existingIndex].fileList.push(...data.fileList.map((f) => ({ ...f, editMode: false })));
      filesLocal.splice(index, 1);
    } else {
      filesLocal[index] = {
        ...currentBlock,
        ...data,
        editMode: false,
        fileList: data.fileList.map((f) => ({ ...f, editMode: false })),
        isNew: false,
      };
    }

    setFilesList(filesLocal);
  };

  const handleDelete = (index) => {
    const filesLocal = cloneDeep(filesList);
    filesLocal.splice(index, 1);
    setFilesList(filesLocal);
  };

  const handleAddNew = () => {
    const filesLocal = cloneDeep(filesList);
    const flatFiles = filesLocal.flatMap((b) => b.fileList);
    const nextSequence = maxBy(flatFiles, ({ sequence }) => Number(sequence))?.sequence || 0;

    const newBlock = {
      claimKey: 0,
      description: undefined,
      documentType: undefined,
      editMode: true,
      fileComments: undefined,
      fileDesc: undefined,
      fileList: [],
      fileName: undefined,
      id: generateUUIDv4(),
      isNew: true,
      originalFileName: undefined,
      sequence: nextSequence + 1,
    };

    setFilesList([newBlock, ...filesLocal]);
  };

  return (
    <div>
      <Row className="align-items-center" justify="space-between">
        <Col />
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew}>Add New Document</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100" />
      <div className="flex-1 custom-scroll-bar">
        <div>
          {filesList.map((row, index) => (
            <PreClaimsFilesCard
              fileDetails={row}
              key={row.id}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
              onFieldsChange={onFieldsChange}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreClaimsFiles;
